import React from "react";
import hombre from "../../assets/images/man/Hombre_compressed.png";
import dama from "../../assets/images/woman/dama_compressed.png";
import "./style.css";

const Parents = () => {
  return (
    <section id="padrinos">
      <div className="container">

        <div className="parents-header" data-aos="fade-up">
          <h2 className="parents-title">Con la Bendición de</h2>
          <div className="parents-rule"></div>
          <p className="parents-quote">
            "Que todo lo que hagan sea hecho con amor."
          </p>
          <p className="parents-verse">1 Corintios 16:14</p>
        </div>

        <ul className="parents-tabs nav nav-tabs" role="tablist" data-aos="fade-up" data-aos-delay="100">
          <li className="nav-item">
            <a className="parents-tab-link nav-link active" href="#nuestra-familia" role="tab" data-bs-toggle="tab">
              Nuestra Familia
            </a>
          </li>
          <li className="nav-item">
            <a className="parents-tab-link nav-link" href="#padrinos-rings" role="tab" data-bs-toggle="tab">
              Nuestros Padrinos
            </a>
          </li>
        </ul>

        <div className="tab-content parents-tab-content" data-aos="fade-up" data-aos-delay="200">

          {/* Nuestra Familia */}
          <div role="tabpanel" className="tab-pane fade show active" id="nuestra-familia">
            <div className="family-grid">

              {/* Familia de la Novia — izquierda */}
              <div className="family-group">
                <p className="family-group-label">Familia de la Novia</p>

                <div className="parents-person">
                  <img className="parents-icon" src={dama} alt="" />
                  <h4 className="parents-name">Rosa Isela Gómez Pérez</h4>
                  <div className="parents-person-rule"></div>
                  <p className="parents-text">
                    Tu amor me ha acompañado en cada etapa de mi vida, creyendo en mí incluso cuando yo dudaba e impulsándome siempre a perseguir mis sueños.
                    Tu fortaleza, entrega y cariño han sido mi ejemplo y mi refugio.
                  </p>
                </div>

                <div className="family-inner-sep" />

                <div className="parents-person">
                  <img className="parents-icon" src={hombre} alt="" />
                  <h4 className="parents-name">Antonio Ramírez Robles</h4>
                  <div className="parents-person-rule"></div>
                  <p className="parents-text">
                    Tu apoyo y cuidado me han acompañado a lo largo de mi vida, enseñándome con tu ejemplo el valor del esfuerzo, la honestidad y el amor por la familia.
                    Caminar a tu lado hasta este momento hace aún más significativo este día para mí.
                  </p>
                </div>
              </div>

              <div className="parents-divider" />

              {/* Familia del Novio — derecha */}
              <div className="family-group">
                <p className="family-group-label">Familia del Novio</p>

                <div className="parents-person">
                  <img className="parents-icon" src={dama} alt="" />
                  <h4 className="parents-name">Ma. Concepción Calderón Leaños</h4>
                  <div className="parents-person-rule"></div>
                  <p className="parents-text">
                    Tu cariño, apoyo y presencia han sido parte importante de mi vida.
                    En ti he encontrado amor, consejo y una compañía incondicional que valoro profundamente.
                    Compartir contigo este momento tan especial llena mi corazón de gratitud y amor.
                  </p>
                </div>

              </div>

            </div>
          </div>

          {/* Nuestros Padrinos */}
          <div role="tabpanel" className="tab-pane fade" id="padrinos-rings">
            <div className="parents-grid">
              <div className="parents-person">
                <img className="parents-icon parents-icon--sm" src="https://img.icons8.com/ios/80/000000/dove.png" alt="" />
                <h4 className="parents-name">
                  Omar Antonio Calderón Hernández<br />
                  <span className="parents-ampersand">&amp;</span><br />
                  Jennefer Nereida Martínez Mercado
                </h4>
                <div className="parents-person-rule"></div>
                <p className="parents-text">
                  Nos honra profundamente compartir este momento con personas tan especiales para nosotros.
                  Su cariño, apoyo y acompañamiento han sido parte importante de nuestro camino, y nos alegra contar con su presencia en el inicio de esta nueva etapa.
                </p>
              </div>
              <div className="parents-divider" />
              <div className="parents-person">
                <img className="parents-icon parents-icon--sm" src="https://img.icons8.com/ios/80/000000/wedding-rings.png" alt="" />
                <h4 className="parents-name">
                  Héctor Eduardo Gómez Pérez<br />
                  <span className="parents-ampersand">&amp;</span><br />
                  Karina Elizabeth Guzmán Valencia
                </h4>
                <div className="parents-person-rule"></div>
                <p className="parents-text">
                  Nos llena de alegría compartir con ustedes este símbolo de amor y compromiso.
                  Su presencia y cariño hacen aún más significativo este momento que recordaremos para siempre.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Parents;
